export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  DateTime: string
}

export type Action = {
  status: ActionStatus
}

export enum ActionStatus {
  failed = 'failed',
  succeeded = 'succeeded',
}

export type AddAppCollaboratorInput = {
  email: Scalars['String']
}

export type App = {
  about?: Maybe<Scalars['String']>
  authorName?: Maybe<Scalars['String']>
  authorUrl?: Maybe<Scalars['String']>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  clientId?: Maybe<Scalars['String']>
  clientSecret?: Maybe<Scalars['String']>
  comingSoon: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  createdById?: Maybe<Scalars['ID']>
  customCodes?: Maybe<AppCustomCodes>
  description?: Maybe<Scalars['String']>
  docsUrl?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  federatedSearchEnabled: Scalars['Boolean']
  federatedSearchUrl?: Maybe<Scalars['String']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  installed?: Maybe<Scalars['Boolean']>
  interactionUrl?: Maybe<Scalars['String']>
  /** Whether the app is a consent management platform */
  isConsentManagementPlatform?: Maybe<Scalars['Boolean']>
  locked: Scalars['Boolean']
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  onFreePlan: Scalars['Boolean']
  privacyPolicyUrl?: Maybe<Scalars['String']>
  redirectUris?: Maybe<Array<Scalars['String']>>
  requiredPermissions: Array<PrimaryScopes>
  requiredTemplates?: Maybe<AppRequiredTemplates>
  secretToken?: Maybe<Scalars['String']>
  slug: Scalars['String']
  standing: StoreItemStanding
  status: StoreItemStatus
  termsOfServiceUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updatedById?: Maybe<Scalars['ID']>
  webhookSignSecret?: Maybe<Scalars['String']>
  webhookSubscriptions?: Maybe<Array<Scalars['String']>>
  webhookUrl?: Maybe<Scalars['String']>
}

export type AppCollaborator = {
  addedById?: Maybe<Scalars['ID']>
  app?: Maybe<App>
  appId: Scalars['ID']
  createdAt: Scalars['DateTime']
  email: Scalars['String']
  id: Scalars['ID']
  type: AppCollaboratorType
}

export enum AppCollaboratorType {
  COLLABORATOR = 'COLLABORATOR',
  OWNER = 'OWNER',
}

export type AppCustomCodes = {
  body?: Maybe<Scalars['String']>
  head?: Maybe<Scalars['String']>
}

export type AppEdge = {
  cursor: Scalars['String']
  node: App
}

export type AppNotificationInput = {
  networkId: Scalars['String']
  template: Scalars['String']
  templateData: Array<TemplateDataInput>
}

export type AppPublication = {
  addedById?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  itemId: Scalars['String']
  networkId: Scalars['String']
}

export type AppRequiredTemplates = {
  postTypeTemplateIds?: Maybe<Array<Scalars['String']>>
  postTypeTemplates?: Maybe<Array<Template>>
}

export type AppRequiredTemplatesInput = {
  postTypeTemplateIds?: InputMaybe<Array<Scalars['String']>>
}

export type AppSettings = {
  appId: Scalars['String']
  context: PermissionContext
  entityId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  networkId: Scalars['String']
  settings: Scalars['String']
}

export type AppToken = {
  accessToken: Scalars['String']
  gatewayUrl?: Maybe<Scalars['String']>
}

export type Availability = {
  available: Scalars['Boolean']
}

export type BaseCustomFieldSchema = {
  archived?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  externalKeys?: Maybe<Array<Scalars['String']>>
  items?: Maybe<BaseCustomFieldSchema>
  key: Scalars['String']
  name: Scalars['String']
  properties?: Maybe<Array<BaseCustomFieldSchema>>
  required?: Maybe<Scalars['Boolean']>
  type: CustomFieldType
  typeOptions?: Maybe<CustomFieldTypeOptions>
  validators?: Maybe<Array<CustomFieldValidator>>
}

export type BaseCustomFieldSchemaInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name: Scalars['String']
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  required?: InputMaybe<Scalars['Boolean']>
  type: CustomFieldType
  typeOptions?: InputMaybe<CustomFieldTypeOptionsInput>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
}

export type Block = {
  children?: Maybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
  output?: Maybe<Scalars['String']>
  props?: Maybe<Scalars['String']>
}

export type BlockInput = {
  children?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  name: Scalars['String']
  output?: InputMaybe<Scalars['String']>
  props?: InputMaybe<Scalars['String']>
}

export type CollaboratorInvitationInput = {
  region: Scalars['String']
  token: Scalars['String']
}

export type CreateAppInput = {
  about?: InputMaybe<Scalars['String']>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  collaborators?: InputMaybe<Array<Scalars['String']>>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  customCodes?: InputMaybe<UpdateAppCustomCodes>
  description?: InputMaybe<Scalars['String']>
  docsUrl?: InputMaybe<Scalars['String']>
  dynamicBlocks?: InputMaybe<Array<CreateDynamicBlockInput>>
  faviconId?: InputMaybe<Scalars['String']>
  federatedSearchEnabled?: InputMaybe<Scalars['Boolean']>
  federatedSearchUrl?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  interactionUrl?: InputMaybe<Scalars['String']>
  isConsentManagementPlatform?: InputMaybe<Scalars['Boolean']>
  name: Scalars['String']
  networkId: Scalars['String']
  onFreePlan?: InputMaybe<Scalars['Boolean']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  redirectUris?: InputMaybe<Array<Scalars['String']>>
  requiredPermissions?: InputMaybe<Array<PrimaryScopes>>
  requiredTemplates?: InputMaybe<AppRequiredTemplatesInput>
  shortcuts?: InputMaybe<Array<CreateShortcutInput>>
  slug?: InputMaybe<Scalars['String']>
  standing?: InputMaybe<StoreItemStanding>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  webhookSubscriptions?: InputMaybe<Array<Scalars['String']>>
  webhookUrl?: InputMaybe<Scalars['String']>
}

export type CreateDynamicBlockInput = {
  contexts?: InputMaybe<Array<PermissionContext>>
  description?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  interactionUrl?: InputMaybe<Scalars['String']>
  key: Scalars['String']
  maxSize?: InputMaybe<DynamicBlockSize>
  name?: InputMaybe<Scalars['String']>
  staffOnly?: InputMaybe<Scalars['Boolean']>
}

export type CreateEmojiInput = {
  text: Scalars['String']
}

export type CreateImageInput = {
  contentType: Scalars['String']
  cropHeight?: InputMaybe<Scalars['Int']>
  cropWidth?: InputMaybe<Scalars['Int']>
  cropX?: InputMaybe<Scalars['Int']>
  cropY?: InputMaybe<Scalars['Int']>
  cropZoom?: InputMaybe<Scalars['Float']>
  height?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  size: Scalars['Float']
  width?: InputMaybe<Scalars['Int']>
}

export type CreateNetwork = {
  domain?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  templateId: Scalars['String']
  utm?: InputMaybe<UtmInput>
}

export type CreatePostTypeInput = {
  allowedReactions?: InputMaybe<Array<Scalars['String']>>
  context: PostTypeContext
  customReactions?: InputMaybe<Array<CustomReactionInput>>
  description?: InputMaybe<Scalars['String']>
  excludedNativeShortcuts?: InputMaybe<Array<Scalars['String']>>
  forbiddenReactions?: InputMaybe<Array<Scalars['String']>>
  iconId?: InputMaybe<Scalars['ID']>
  languageTemplate?: InputMaybe<Scalars['String']>
  layout?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  nativeFieldsTemplates?: InputMaybe<NativeFieldsTemplatesInput>
  pluralName: Scalars['String']
  postFields?: InputMaybe<CustomFieldsSchemaInput>
  primaryReactionType: ReactionType
  recommendationsSettings?: InputMaybe<PostTypeRecommendationSettingsInput>
  selfRepliable?: InputMaybe<Scalars['Boolean']>
  shortContentTemplate?: InputMaybe<Scalars['String']>
  singleChoiceReactions?: InputMaybe<Array<Scalars['String']>>
  slate?: InputMaybe<SlateInput>
  titleTemplate?: InputMaybe<Scalars['String']>
  validReplyTypesIds?: InputMaybe<Array<Scalars['String']>>
}

export type CreatePostTypeTemplateInput = {
  about?: InputMaybe<Scalars['String']>
  appIds?: InputMaybe<Array<Scalars['String']>>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<Scalars['String']>>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  descriptions?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  networkId: Scalars['String']
  onFreePlan?: InputMaybe<Scalars['Boolean']>
  postTypeInput: CreatePostTypeInput
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  slug: Scalars['String']
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
}

export type CreateShortcutInput = {
  context: PermissionContext
  description?: InputMaybe<Scalars['String']>
  entityType?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['ID']>
  interactionUrl?: InputMaybe<Scalars['String']>
  key: Scalars['String']
  name: Scalars['String']
  states?: InputMaybe<Array<ShortcutStateInput>>
}

export type CustomFieldPrivacy = {
  allow: Array<CustomFieldPrivacyOptions>
}

export type CustomFieldPrivacyInput = {
  allow: Array<CustomFieldPrivacyOptions>
}

export enum CustomFieldPrivacyOptions {
  ADMIN = 'ADMIN',
  OWN = 'OWN',
}

export type CustomFieldSchema = {
  archived?: Maybe<Scalars['Boolean']>
  default?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  externalKeys?: Maybe<Array<Scalars['String']>>
  items?: Maybe<BaseCustomFieldSchema>
  key: Scalars['String']
  name: Scalars['String']
  properties?: Maybe<Array<BaseCustomFieldSchema>>
  readPrivacy?: Maybe<CustomFieldPrivacy>
  required?: Maybe<Scalars['Boolean']>
  searchable?: Maybe<Scalars['Boolean']>
  settings?: Maybe<Array<CustomFieldSettings>>
  type: CustomFieldType
  typeOptions?: Maybe<CustomFieldTypeOptions>
  validators?: Maybe<Array<CustomFieldValidator>>
  writePrivacy?: Maybe<CustomFieldPrivacy>
}

export type CustomFieldSchemaInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  default?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  externalKeys?: InputMaybe<Array<Scalars['String']>>
  items?: InputMaybe<BaseCustomFieldSchemaInput>
  key: Scalars['String']
  name: Scalars['String']
  properties?: InputMaybe<Array<BaseCustomFieldSchemaInput>>
  readPrivacy?: InputMaybe<CustomFieldPrivacyInput>
  required?: InputMaybe<Scalars['Boolean']>
  searchable?: InputMaybe<Scalars['Boolean']>
  settings?: InputMaybe<Array<CustomFieldSettingsInput>>
  type: CustomFieldType
  typeOptions?: InputMaybe<CustomFieldTypeOptionsInput>
  validators?: InputMaybe<Array<CustomFieldValidatorInput>>
  writePrivacy?: InputMaybe<CustomFieldPrivacyInput>
}

export type CustomFieldSettings = {
  key: Scalars['String']
  value: Scalars['String']
}

export type CustomFieldSettingsInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export enum CustomFieldType {
  array = 'array',
  boolean = 'boolean',
  date = 'date',
  number = 'number',
  object = 'object',
  relation = 'relation',
  richText = 'richText',
  text = 'text',
}

export type CustomFieldTypeOptions = {
  dateType?: Maybe<DateTypeOptions>
  numberType?: Maybe<NumberTypeOptions>
  relationType?: Maybe<RelationTypeOptions>
  richTextType?: Maybe<RichTextTypeOptions>
  textType?: Maybe<TextTypeOptions>
}

export type CustomFieldTypeOptionsInput = {
  dateType?: InputMaybe<DateTypeOptions>
  numberType?: InputMaybe<NumberTypeOptions>
  relationType?: InputMaybe<RelationTypeOptions>
  richTextType?: InputMaybe<RichTextTypeOptions>
  textType?: InputMaybe<TextTypeOptions>
}

export type CustomFieldValidator = {
  customErrorMessage?: Maybe<Scalars['String']>
  validation: CustomFieldValidators
  value: Scalars['String']
}

export type CustomFieldValidatorInput = {
  customErrorMessage?: InputMaybe<Scalars['String']>
  validation: CustomFieldValidators
  value: Scalars['String']
}

export enum CustomFieldValidators {
  allOf = 'allOf',
  anyOf = 'anyOf',
  enum = 'enum',
  exclusiveMaximum = 'exclusiveMaximum',
  exclusiveMinimum = 'exclusiveMinimum',
  format = 'format',
  maxItems = 'maxItems',
  maxLength = 'maxLength',
  maxProperties = 'maxProperties',
  maximum = 'maximum',
  minItems = 'minItems',
  minLength = 'minLength',
  minProperties = 'minProperties',
  minimum = 'minimum',
  multipleOf = 'multipleOf',
  not = 'not',
  oneOf = 'oneOf',
  pattern = 'pattern',
  uniqueItems = 'uniqueItems',
}

export type CustomFieldsSchemaInput = {
  fields: Array<CustomFieldSchemaInput>
}

export type CustomReactionInput = {
  activeColor?: InputMaybe<Scalars['String']>
  activeGlyphId?: InputMaybe<Scalars['String']>
  activeName?: InputMaybe<Scalars['String']>
  color?: InputMaybe<Scalars['String']>
  glyphId: Scalars['String']
  key: Scalars['String']
  name: Scalars['String']
}

export enum DateTypeOptions {
  date = 'date',
  datetime = 'datetime',
}

export enum DefaultDynamicBlockKeys {
  settings = 'settings',
}

export type DeleteNetworkInput = {
  networkId: Scalars['String']
}

export type DynamicBlock = {
  about?: Maybe<Scalars['String']>
  app?: Maybe<App>
  appId: Scalars['String']
  contexts?: Maybe<Array<PermissionContext>>
  createdAt: Scalars['DateTime']
  createdById?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  interactionUrl?: Maybe<Scalars['String']>
  key: Scalars['String']
  maxSize: DynamicBlockSize
  name: Scalars['String']
  staffOnly: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
  updatedById?: Maybe<Scalars['ID']>
}

export type DynamicBlockEdge = {
  cursor: Scalars['String']
  node: DynamicBlock
}

export enum DynamicBlockSize {
  full = 'full',
  lg = 'lg',
  md = 'md',
  sm = 'sm',
  xl = 'xl',
}

export type EmailValidationResult = {
  suggestion?: Maybe<Scalars['String']>
  valid: Scalars['Boolean']
}

export type Embed = {
  author?: Maybe<Scalars['String']>
  author_url?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  html?: Maybe<Scalars['String']>
  id: Scalars['ID']
  options?: Maybe<Scalars['String']>
  provider_name?: Maybe<Scalars['String']>
  thumbnail_height?: Maybe<Scalars['String']>
  thumbnail_url?: Maybe<Scalars['String']>
  thumbnail_width?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  url: Scalars['String']
}

export type EmbedInput = {
  options?: InputMaybe<Scalars['String']>
  url: Scalars['String']
}

export type Emoji = {
  id: Scalars['ID']
  text: Scalars['String']
}

export type EnableDefaultDynamicBlockInput = {
  contexts?: InputMaybe<Array<PermissionContext>>
  interactionUrl?: InputMaybe<Scalars['String']>
}

export enum EventNoun {
  APP = 'APP',
  APP_INSTALLATION = 'APP_INSTALLATION',
  BADGE = 'BADGE',
  COLLECTION = 'COLLECTION',
  CUSTOM = 'CUSTOM',
  EMBED = 'EMBED',
  EXTRA_PROPERTY = 'EXTRA_PROPERTY',
  IMPORT_REQUEST = 'IMPORT_REQUEST',
  LIMITS = 'LIMITS',
  MEDIA = 'MEDIA',
  MEMBER = 'MEMBER',
  MEMBER_BADGE = 'MEMBER_BADGE',
  MEMBER_INVITATION = 'MEMBER_INVITATION',
  MEMBER_LAST_SEEN = 'MEMBER_LAST_SEEN',
  MEMBER_SESSION = 'MEMBER_SESSION',
  MEMBER_STATS = 'MEMBER_STATS',
  MODERATION = 'MODERATION',
  NETWORK = 'NETWORK',
  NETWORK_STATS = 'NETWORK_STATS',
  ORGANIZATION = 'ORGANIZATION',
  PAGE_CUSTOM_RESPONSE = 'PAGE_CUSTOM_RESPONSE',
  PLAN = 'PLAN',
  POST = 'POST',
  POST_TYPE = 'POST_TYPE',
  PRODUCT = 'PRODUCT',
  PRODUCT_PRICE_SYNC = 'PRODUCT_PRICE_SYNC',
  REACTION = 'REACTION',
  ROLE = 'ROLE',
  SHORTCUT = 'SHORTCUT',
  SPACE = 'SPACE',
  SPACE_JOIN_REQUEST = 'SPACE_JOIN_REQUEST',
  SPACE_MEMBERSHIP = 'SPACE_MEMBERSHIP',
  SPACE_NETWORK_ROLE = 'SPACE_NETWORK_ROLE',
  SPACE_POST_TYPE = 'SPACE_POST_TYPE',
  SPACE_ROLE = 'SPACE_ROLE',
  SSO = 'SSO',
  SSO_MEMBERSHIP = 'SSO_MEMBERSHIP',
  STAFF_STATS = 'STAFF_STATS',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SYNC_EVENT = 'SYNC_EVENT',
  TAG = 'TAG',
  TRACKER = 'TRACKER',
}

export type EventType = {
  description: Scalars['String']
  name: Scalars['String']
  noun: EventNoun
  requiredScope: Scalars['String']
  shortDescription: Scalars['String']
  verb: EventVerb
}

export enum EventVerb {
  ACCEPTED = 'ACCEPTED',
  ADDED = 'ADDED',
  BANNED = 'BANNED',
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CLICKED = 'CLICKED',
  CREATED = 'CREATED',
  CUSTOM = 'CUSTOM',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FOLLOWED = 'FOLLOWED',
  GENERATED = 'GENERATED',
  HIDDEN = 'HIDDEN',
  IMPRESSION = 'IMPRESSION',
  INSTALLED = 'INSTALLED',
  LOGGED_IN = 'LOGGED_IN',
  MARKED_FOR_PURGE = 'MARKED_FOR_PURGE',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  PERMITTED = 'PERMITTED',
  PING = 'PING',
  PINGED = 'PINGED',
  PINNED = 'PINNED',
  PUBLISHED = 'PUBLISHED',
  PURGED = 'PURGED',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  REMOVED = 'REMOVED',
  RESENT = 'RESENT',
  REVOKED = 'REVOKED',
  SENT = 'SENT',
  SIGNED_UP = 'SIGNED_UP',
  SUCCEEDED = 'SUCCEEDED',
  SUSPENDED = 'SUSPENDED',
  UNBLOCKED = 'UNBLOCKED',
  UNFOLLOWED = 'UNFOLLOWED',
  UNHIDDEN = 'UNHIDDEN',
  UNINSTALLED = 'UNINSTALLED',
  UNPINNED = 'UNPINNED',
  UNPUBLISHED = 'UNPUBLISHED',
  UNSUSPENDED = 'UNSUSPENDED',
  UNUSED = 'UNUSED',
  UNVERIFIED = 'UNVERIFIED',
  UPDATED = 'UPDATED',
  USED = 'USED',
  VERIFIED = 'VERIFIED',
  VIEWED = 'VIEWED',
}

export type File = {
  downloadUrl: Scalars['String']
  extension: Scalars['String']
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['Int']>
  url: Scalars['String']
}

export type GlobalMember = {
  createdAt: Scalars['DateTime']
  email: Scalars['String']
  id: Scalars['ID']
  joinedReferralProgram: Scalars['Boolean']
  locale: Scalars['String']
  name?: Maybe<Scalars['String']>
  profilePicture?: Maybe<Media>
  profilePictureId?: Maybe<Scalars['ID']>
  referrerCode?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type GlobalToken = {
  accessToken: Scalars['String']
  email: Scalars['String']
}

export type GlobalTokenInput = {
  email: Scalars['String']
  referrerCode?: InputMaybe<Scalars['String']>
  verificationCode: Scalars['String']
}

export type Glyph = {
  id: Scalars['ID']
  text: Scalars['String']
  variant: GlyphMediaVariant
}

export enum GlyphMediaVariant {
  emoji = 'emoji',
  icon = 'icon',
}

export type HubContent = {
  attachmentIds: Array<Scalars['ID']>
  attachments?: Maybe<Array<File>>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  fields?: Maybe<Array<HubContentCustomField>>
  id: Scalars['ID']
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  language?: Maybe<Scalars['String']>
  /** Whether the post is locked */
  locked: Scalars['Boolean']
  postTypeId: Scalars['ID']
  publishedAt?: Maybe<Scalars['DateTime']>
  slug?: Maybe<Scalars['String']>
  tagIds?: Maybe<Array<Scalars['String']>>
  thumbnail?: Maybe<Media>
  thumbnailId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type HubContentCustomField = {
  key: Scalars['String']
  relationEntities?: Maybe<HubContentCustomFieldRelation>
  value?: Maybe<Scalars['String']>
}

export type HubContentCustomFieldRelation = {
  medias: Array<Media>
}

export type Image = {
  cropHeight?: Maybe<Scalars['Int']>
  cropWidth?: Maybe<Scalars['Int']>
  cropX: Scalars['Int']
  cropY: Scalars['Int']
  cropZoom: Scalars['Float']
  dominantColorHex?: Maybe<Scalars['String']>
  downloadUrl: Scalars['String']
  dpi?: Maybe<Scalars['Float']>
  height?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  url: Scalars['String']
  urls?: Maybe<MediaUrls>
  width?: Maybe<Scalars['Float']>
}

export type InvitationAcceptResult = {
  /** Access token won’t be provided if there’s an error with the invitation */
  accessToken?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  /** In case of an error with invitation, message will contain the error description. */
  errorMessage?: Maybe<Scalars['String']>
  networkId?: Maybe<Scalars['String']>
  networkPath?: Maybe<Scalars['String']>
  status: ActionStatus
}

export type LoginNetwork = {
  networkId: Scalars['String']
}

export type LoginWithSsoCodeInput = {
  code?: InputMaybe<Scalars['String']>
  hd?: InputMaybe<Scalars['String']>
  oauth_token?: InputMaybe<Scalars['String']>
  oauth_verifier?: InputMaybe<Scalars['String']>
  prompt?: InputMaybe<Scalars['String']>
  referrer_code?: InputMaybe<Scalars['String']>
  scope?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
}

export type Media = Emoji | File | Glyph | Image

export type MediaUrls = {
  full: Scalars['String']
  large: Scalars['String']
  medium: Scalars['String']
  small: Scalars['String']
  thumb: Scalars['String']
}

export type Mutation = {
  acceptCollaboratorInvitation: InvitationAcceptResult
  addAppCollaborator: AppCollaborator
  createApp: App
  createDynamicBlock: DynamicBlock
  /** @deprecated Use Glyphs instead, just update the media id with `emoji/...` */
  createEmojis: Array<Emoji>
  createImages: Array<SignedUrl>
  createNetwork: NetworkOtp
  createPostTypeTemplate: Template
  createShortcut: Shortcut
  deleteApp: Action
  deleteAppSetting: AppSettings
  deleteDynamicBlock: Action
  deleteNetwork: Action
  deleteShortcut: Action
  disableDefaultDynamicBlock: Action
  enableDefaultDynamicBlock: DynamicBlock
  joinReferralProgram: GlobalMember
  publishApp: Action
  publishAppPrivately: AppPublication
  regenerateClientSecret: App
  removeAppCollaborator: Action
  requestGlobalTokenCode: Action
  resendGlobalTokenCode: Action
  sendNotifications: SendNotifications
  testAppWebhook: Action
  unPublishAppPrivately: Action
  unpublishApp: Action
  updateApp: App
  updateAppSetting: AppSettings
  updateAuthMember: GlobalMember
  updateDynamicBlock: DynamicBlock
  updateShortcut: Shortcut
  validateEmail: EmailValidationResult
}

export type MutationAcceptCollaboratorInvitationArgs = {
  input: CollaboratorInvitationInput
}

export type MutationAddAppCollaboratorArgs = {
  appId: Scalars['String']
  input: AddAppCollaboratorInput
}

export type MutationCreateAppArgs = {
  input: CreateAppInput
}

export type MutationCreateDynamicBlockArgs = {
  appId: Scalars['ID']
  input: CreateDynamicBlockInput
}

export type MutationCreateEmojisArgs = {
  input: Array<CreateEmojiInput>
}

export type MutationCreateImagesArgs = {
  input: Array<CreateImageInput>
}

export type MutationCreateNetworkArgs = {
  input: CreateNetwork
}

export type MutationCreatePostTypeTemplateArgs = {
  input: CreatePostTypeTemplateInput
}

export type MutationCreateShortcutArgs = {
  appId: Scalars['String']
  input: CreateShortcutInput
}

export type MutationDeleteAppArgs = {
  id: Scalars['ID']
}

export type MutationDeleteAppSettingArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
}

export type MutationDeleteDynamicBlockArgs = {
  appId: Scalars['ID']
  blockId: Scalars['ID']
}

export type MutationDeleteNetworkArgs = {
  input: DeleteNetworkInput
}

export type MutationDeleteShortcutArgs = {
  appId: Scalars['String']
  id: Scalars['ID']
}

export type MutationDisableDefaultDynamicBlockArgs = {
  appId: Scalars['ID']
  key: DefaultDynamicBlockKeys
}

export type MutationEnableDefaultDynamicBlockArgs = {
  appId: Scalars['ID']
  input: EnableDefaultDynamicBlockInput
  key: DefaultDynamicBlockKeys
}

export type MutationPublishAppArgs = {
  id: Scalars['ID']
}

export type MutationPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationRegenerateClientSecretArgs = {
  appId: Scalars['ID']
}

export type MutationRemoveAppCollaboratorArgs = {
  appId: Scalars['String']
  collaboratorId: Scalars['String']
}

export type MutationRequestGlobalTokenCodeArgs = {
  input: RequestGlobalTokenInput
}

export type MutationResendGlobalTokenCodeArgs = {
  input: RequestGlobalTokenInput
}

export type MutationSendNotificationsArgs = {
  input: AppNotificationInput
}

export type MutationTestAppWebhookArgs = {
  appId: Scalars['ID']
  input: TestAppWebhookInput
}

export type MutationUnPublishAppPrivatelyArgs = {
  appId: Scalars['ID']
  networkId: Scalars['ID']
}

export type MutationUnpublishAppArgs = {
  id: Scalars['ID']
}

export type MutationUpdateAppArgs = {
  id: Scalars['ID']
  input: UpdateAppInput
}

export type MutationUpdateAppSettingArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
  settings: Scalars['String']
}

export type MutationUpdateAuthMemberArgs = {
  input: UpdateGlobalMemberInput
}

export type MutationUpdateDynamicBlockArgs = {
  appId: Scalars['ID']
  blockId: Scalars['ID']
  input: UpdateDynamicBlockInput
}

export type MutationUpdateShortcutArgs = {
  appId: Scalars['String']
  id: Scalars['ID']
  input: UpdateShortcutInput
}

export type MutationValidateEmailArgs = {
  input: RequestGlobalTokenInput
}

export type NativeFieldsTemplatesInput = {
  description?: InputMaybe<Scalars['String']>
  thumbnailId?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type Network = {
  activeTheme?: Maybe<Theme>
  aliases: Array<Scalars['String']>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  domain: Scalars['String']
  domainSubfolder?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  gatewayUrl: Scalars['String']
  id: Scalars['ID']
  images?: Maybe<NetworkImages>
  isOwner: Scalars['Boolean']
  logo?: Maybe<Media>
  logoId?: Maybe<Scalars['ID']>
  membership: NetworkMembership
  name: Scalars['String']
  overUsedAt?: Maybe<Scalars['DateTime']>
  planName: Scalars['String']
  status: NetworkStatus
  visibility: NetworkVisibility
  willUnpublishAt?: Maybe<Scalars['DateTime']>
}

export type NetworkEdge = {
  cursor: Scalars['String']
  node: Network
}

export type NetworkImages = {
  darkFavicon?: Maybe<Media>
  darkLogo?: Maybe<Media>
  darkMobileLogo?: Maybe<Media>
  lightFavicon?: Maybe<Media>
  lightLogo?: Maybe<Media>
  lightMobileLogo?: Maybe<Media>
}

export enum NetworkMembership {
  inviteOnly = 'inviteOnly',
  open = 'open',
}

export type NetworkOtp = {
  domain: Scalars['String']
  /** The path to the network. This property takes subfolder settings into account. */
  networkPath: Scalars['String']
  otp: Scalars['String']
}

export enum NetworkStatus {
  archived = 'archived',
  published = 'published',
  unpublished = 'unpublished',
}

export enum NetworkVisibility {
  private = 'private',
  public = 'public',
}

export enum NumberTypeOptions {
  integer = 'integer',
  number = 'number',
}

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>
  hasNextPage: Scalars['Boolean']
}

export type PaginatedApp = {
  edges?: Maybe<Array<AppEdge>>
  nodes?: Maybe<Array<App>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedDynamicBlock = {
  edges?: Maybe<Array<DynamicBlockEdge>>
  nodes?: Maybe<Array<DynamicBlock>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedShortcut = {
  edges?: Maybe<Array<ShortcutEdge>>
  nodes?: Maybe<Array<Shortcut>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export type PaginatedTemplate = {
  edges?: Maybe<Array<TemplateEdge>>
  nodes?: Maybe<Array<Template>>
  pageInfo: PageInfo
  totalCount?: Maybe<Scalars['Int']>
}

export enum PermissionContext {
  MEMBER = 'MEMBER',
  NETWORK = 'NETWORK',
  POST = 'POST',
  SPACE = 'SPACE',
}

export enum PostTypeContext {
  post = 'post',
  reply = 'reply',
}

export type PostTypeRecommendationSettingsInput = {
  fields: Array<Scalars['String']>
  sourceSelf?: InputMaybe<Scalars['Boolean']>
  sourceSpaces?: InputMaybe<Array<Scalars['String']>>
}

export enum PrimaryScopes {
  CreateContent = 'CreateContent',
  DeleteAuthMember = 'DeleteAuthMember',
  DeleteContent = 'DeleteContent',
  DeleteMember = 'DeleteMember',
  DeleteNetwork = 'DeleteNetwork',
  FindAuthMember = 'FindAuthMember',
  FindContent = 'FindContent',
  FindNetwork = 'FindNetwork',
  FullAccess = 'FullAccess',
  InviteMember = 'InviteMember',
  JoinNetwork = 'JoinNetwork',
  UpdateAuthMember = 'UpdateAuthMember',
  UpdateBilling = 'UpdateBilling',
  UpdateContent = 'UpdateContent',
  UpdateMember = 'UpdateMember',
  UpdateModeration = 'UpdateModeration',
  UpdateNetwork = 'UpdateNetwork',
  UpdateNetworkTemplate = 'UpdateNetworkTemplate',
  UpdateReport = 'UpdateReport',
  ViewAuthMember = 'ViewAuthMember',
  ViewContent = 'ViewContent',
  ViewMember = 'ViewMember',
  ViewNetwork = 'ViewNetwork',
  ViewReport = 'ViewReport',
}

export type Query = {
  app: App
  appCollaborators: Array<AppCollaborator>
  appPublications: Array<AppPublication>
  appSettings: AppSettings
  apps: PaginatedApp
  authMember: GlobalMember
  checkAppSlugAvailability: Availability
  dynamicBlock: DynamicBlock
  dynamicBlocks: PaginatedDynamicBlock
  embed: Embed
  eventTypes: Array<EventType>
  globalToken: GlobalToken
  limitedToken: AppToken
  loginWithSsoCode: GlobalToken
  media: Media
  networkOtp: NetworkOtp
  networks: Array<Network>
  shortcut: Shortcut
  shortcuts: PaginatedShortcut
  ssoUrl: SsoUrl
  templates: PaginatedTemplate
}

export type QueryAppArgs = {
  id?: InputMaybe<Scalars['ID']>
  slug?: InputMaybe<Scalars['String']>
}

export type QueryAppCollaboratorsArgs = {
  appId: Scalars['String']
}

export type QueryAppPublicationsArgs = {
  appId: Scalars['ID']
}

export type QueryAppSettingsArgs = {
  context: PermissionContext
  entityId?: InputMaybe<Scalars['ID']>
  networkId: Scalars['ID']
}

export type QueryAppsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  standing?: InputMaybe<StoreItemStanding>
  status?: InputMaybe<StoreItemStatus>
}

export type QueryCheckAppSlugAvailabilityArgs = {
  slug: Scalars['String']
}

export type QueryDynamicBlockArgs = {
  appId: Scalars['ID']
  blockId: Scalars['ID']
}

export type QueryDynamicBlocksArgs = {
  after?: InputMaybe<Scalars['String']>
  appId: Scalars['ID']
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QueryEmbedArgs = {
  input: EmbedInput
}

export type QueryGlobalTokenArgs = {
  input: GlobalTokenInput
}

export type QueryLimitedTokenArgs = {
  context?: InputMaybe<PermissionContext>
  entityId?: InputMaybe<Scalars['String']>
  impersonateMemberId?: InputMaybe<Scalars['String']>
  networkId: Scalars['String']
}

export type QueryLoginWithSsoCodeArgs = {
  input: LoginWithSsoCodeInput
}

export type QueryMediaArgs = {
  id: Scalars['ID']
}

export type QueryNetworkOtpArgs = {
  input: LoginNetwork
}

export type QueryShortcutArgs = {
  appId: Scalars['String']
  id: Scalars['String']
}

export type QueryShortcutsArgs = {
  after?: InputMaybe<Scalars['String']>
  appId: Scalars['String']
  before?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
}

export type QuerySsoUrlArgs = {
  input: SsoUrlInput
}

export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityTypes?: InputMaybe<Array<TemplateEntityType>>
  limit: Scalars['Int']
  offset?: InputMaybe<Scalars['Int']>
  reverse?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<StoreItemStatus>
}

export enum ReactionType {
  EMOJI_BASE = 'EMOJI_BASE',
  LIKE_BASE = 'LIKE_BASE',
  VOTE_BASE = 'VOTE_BASE',
}

export enum RelationTypeOptions {
  Media = 'Media',
  Member = 'Member',
  Post = 'Post',
  Space = 'Space',
  Tag = 'Tag',
}

export type RequestGlobalTokenInput = {
  captchaToken?: InputMaybe<Scalars['String']>
  email: Scalars['String']
}

export enum RichTextTypeOptions {
  html = 'html',
  markup = 'markup',
}

export type SendNotifications = {
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  networkId: Scalars['String']
  template: Scalars['String']
  templateData: Array<TemplateData>
  updatedAt: Scalars['DateTime']
}

export type Shortcut = {
  appId: Scalars['ID']
  context: PermissionContext
  createdAt: Scalars['DateTime']
  createdById?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  entityType?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  interactionUrl?: Maybe<Scalars['String']>
  key: Scalars['String']
  name: Scalars['String']
  states?: Maybe<Array<ShortcutState>>
  updatedAt: Scalars['DateTime']
  updatedById?: Maybe<Scalars['ID']>
}

export type ShortcutEdge = {
  cursor: Scalars['String']
  node: Shortcut
}

export type ShortcutState = {
  description?: Maybe<Scalars['String']>
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  state: Scalars['String']
}

export type ShortcutStateInput = {
  description?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  state: Scalars['String']
}

export type SignedUrl = {
  fields: Scalars['String']
  mediaDownloadUrl: Scalars['String']
  mediaId: Scalars['ID']
  mediaUrl: Scalars['String']
  signedUrl: Scalars['String']
  urls?: Maybe<MediaUrls>
}

export type Slate = {
  blocks: Array<Block>
  id?: Maybe<Scalars['String']>
  restrictions?: Maybe<SlateRestrictions>
  rootBlock: Scalars['String']
}

export type SlateInput = {
  blocks: Array<BlockInput>
  rootBlock: Scalars['String']
}

export type SlateRestrictions = {
  lockedChildrenBlocks?: Maybe<Array<Scalars['String']>>
  nonEditableBlocks?: Maybe<Array<Scalars['String']>>
  nonRemovableBlocks?: Maybe<Array<Scalars['String']>>
}

export type SsoUrl = {
  url: Scalars['String']
}

export type SsoUrlInput = {
  callbackUrl: Scalars['String']
}

export enum StoreItemStanding {
  OFFICIAL = 'OFFICIAL',
  REGULAR = 'REGULAR',
  VERIFIED = 'VERIFIED',
}

export enum StoreItemStatus {
  DELETED = 'DELETED',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export type Template = {
  about?: Maybe<Scalars['String']>
  appIds: Array<Scalars['String']>
  apps?: Maybe<Array<App>>
  authorName?: Maybe<Scalars['String']>
  authorUrl?: Maybe<Scalars['String']>
  banner?: Maybe<Media>
  bannerId?: Maybe<Scalars['ID']>
  categories: Array<Scalars['String']>
  comingSoon: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  createdById?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  embedIds: Array<Scalars['ID']>
  embeds?: Maybe<Array<Embed>>
  entityProperties: Scalars['String']
  entityType: TemplateEntityType
  favicon?: Maybe<Media>
  faviconId?: Maybe<Scalars['ID']>
  hubContent?: Maybe<HubContent>
  hubContentId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  image?: Maybe<Media>
  imageId?: Maybe<Scalars['ID']>
  imageIds: Array<Scalars['ID']>
  images?: Maybe<Array<Media>>
  installed?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  network?: Maybe<Network>
  networkId: Scalars['ID']
  onFreePlan: Scalars['Boolean']
  privacyPolicyUrl?: Maybe<Scalars['String']>
  requiredTemplateIds: Array<Scalars['String']>
  requiredTemplates?: Maybe<Array<Template>>
  slate?: Maybe<Slate>
  slug: Scalars['String']
  standing: StoreItemStanding
  status: StoreItemStatus
  termsOfServiceUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  updatedById?: Maybe<Scalars['ID']>
}

export type TemplateData = {
  data: Scalars['String']
  memberId: Scalars['String']
  preHeaderText: Scalars['String']
  subject: Scalars['String']
}

export type TemplateDataInput = {
  data: Scalars['String']
  memberId: Scalars['String']
  preHeaderText: Scalars['String']
  subject: Scalars['String']
}

export type TemplateEdge = {
  cursor: Scalars['String']
  node: Template
}

export enum TemplateEntityType {
  Collection = 'Collection',
  Network = 'Network',
  Post = 'Post',
  PostType = 'PostType',
  Space = 'Space',
  SpacePostType = 'SpacePostType',
  Tag = 'Tag',
}

export type TestAppWebhookInput = {
  webhookUrl: Scalars['String']
}

export enum TextTypeOptions {
  fullText = 'fullText',
  shortText = 'shortText',
}

export type Theme = {
  colorTokens?: Maybe<ThemeColorTokens>
  colors?: Maybe<ThemeColors>
  id: Scalars['String']
  name?: Maybe<Scalars['String']>
  typography?: Maybe<Array<ThemeToken>>
}

export type ThemeColor = {
  key: Scalars['String']
  weights: Array<ThemeToken>
}

export type ThemeColorToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type ThemeColorTokens = {
  dark?: Maybe<Array<ThemeColorToken>>
  light?: Maybe<Array<ThemeColorToken>>
}

export type ThemeColors = {
  dark?: Maybe<Array<ThemeColor>>
  light?: Maybe<Array<ThemeColor>>
}

export type ThemeToken = {
  key: Scalars['String']
  value: Scalars['String']
}

export type UpdateAppCustomCodes = {
  body?: InputMaybe<Scalars['String']>
  head?: InputMaybe<Scalars['String']>
}

export type UpdateAppInput = {
  about?: InputMaybe<Scalars['String']>
  authorName?: InputMaybe<Scalars['String']>
  authorUrl?: InputMaybe<Scalars['String']>
  bannerId?: InputMaybe<Scalars['String']>
  collaborators?: InputMaybe<Array<Scalars['String']>>
  comingSoon?: InputMaybe<Scalars['Boolean']>
  customCodes?: InputMaybe<UpdateAppCustomCodes>
  description?: InputMaybe<Scalars['String']>
  docsUrl?: InputMaybe<Scalars['String']>
  dynamicBlocks?: InputMaybe<Array<CreateDynamicBlockInput>>
  faviconId?: InputMaybe<Scalars['String']>
  federatedSearchEnabled?: InputMaybe<Scalars['Boolean']>
  federatedSearchUrl?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  interactionUrl?: InputMaybe<Scalars['String']>
  isConsentManagementPlatform?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  onFreePlan?: InputMaybe<Scalars['Boolean']>
  privacyPolicyUrl?: InputMaybe<Scalars['String']>
  redirectUris?: InputMaybe<Array<Scalars['String']>>
  requiredPermissions?: InputMaybe<Array<PrimaryScopes>>
  requiredTemplates?: InputMaybe<AppRequiredTemplatesInput>
  shortcuts?: InputMaybe<Array<CreateShortcutInput>>
  slug?: InputMaybe<Scalars['String']>
  standing?: InputMaybe<StoreItemStanding>
  termsOfServiceUrl?: InputMaybe<Scalars['String']>
  webhookSubscriptions?: InputMaybe<Array<Scalars['String']>>
  webhookUrl?: InputMaybe<Scalars['String']>
}

export type UpdateDynamicBlockInput = {
  contexts?: InputMaybe<Array<PermissionContext>>
  description?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<Scalars['String']>
  interactionUrl?: InputMaybe<Scalars['String']>
  key?: InputMaybe<Scalars['String']>
  maxSize?: InputMaybe<DynamicBlockSize>
  name?: InputMaybe<Scalars['String']>
  staffOnly?: InputMaybe<Scalars['Boolean']>
}

export type UpdateGlobalMemberInput = {
  locale?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  profilePictureId?: InputMaybe<Scalars['ID']>
}

export type UpdateShortcutInput = {
  context?: InputMaybe<PermissionContext>
  description?: InputMaybe<Scalars['String']>
  entityType?: InputMaybe<Scalars['String']>
  faviconId?: InputMaybe<Scalars['ID']>
  interactionUrl?: InputMaybe<Scalars['String']>
  key?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  states?: InputMaybe<Array<ShortcutStateInput>>
}

export type UtmInput = {
  gclid?: InputMaybe<Scalars['String']>
  utmCampaign?: InputMaybe<Scalars['String']>
  utmContent?: InputMaybe<Scalars['String']>
  utmMedium?: InputMaybe<Scalars['String']>
  utmSource?: InputMaybe<Scalars['String']>
  utmTerm?: InputMaybe<Scalars['String']>
}

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Media: ['Emoji', 'File', 'Glyph', 'Image'],
  },
}
// eslint-disable-next-line import/no-default-export
export default result
